import { VCPM } from '../models/project.model';

/**
 * Ported as-is from ManagementDomainSizingComponent.isRequestValid
 * (management-domain-sizing.component.ts:241-255). Preserves the bare
 * boolean return shape - not unified with WorkloadValidationResult.
 */
export function validateManagementDomains(project: VCPM.Project): boolean {
  const md = project.data.managementDomain;
  if (!md) {
    return false;
  }
  // Check for S/W Components
  if (
    !(
      md.selectedComponents &&
      md.selectedComponents.swComponents &&
      Array.isArray(md.selectedComponents.swComponents) &&
      md.selectedComponents.swComponents.length > 1
    )
  ) {
    return false;
  }

  if (!md.configuration) {
    return false;
  }
  return true;
}
